export function shareRoot(word1, word2) {
  const w = word1.toLowerCase();
  const a = word2.toLowerCase();
  if (w === a) return true;

  // Strip common suffixes to get stems
  function stem(s) {
    return s
      .replace(/(ness|ment|tion|sion|ious|eous|ious|ence|ance|able|ible|ful|less|ly|ing|ings|ed|er|ers|est|ity|al|ous|ive|ize|ise|ent|ant|ist|ism)$/, '')
      .replace(/(at|in|it)e$/, '$1');
  }

  // Check if one starts with the other (min 4 chars)
  const shorter = w.length < a.length ? w : a;
  const longer = w.length < a.length ? a : w;
  if (shorter.length >= 4 && longer.startsWith(shorter)) return true;

  // Check if stems match
  const ws = stem(w);
  const as = stem(a);
  if (ws.length >= 4 && as.length >= 4 && (ws === as || ws.startsWith(as) || as.startsWith(ws))) return true;

  // Check shared prefix of at least 5 chars
  const minLen = Math.min(w.length, a.length);
  let shared = 0;
  for (let i = 0; i < minLen; i++) {
    if (w[i] === a[i]) shared++;
    else break;
  }
  if (shared >= 5) return true;

  return false;
}
